import { createContext, ReactNode } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export const EditorContext = createContext<{ editor: any }>({ editor: null });

const EditorContextProvider = ({ children }: { children: ReactNode }) => {
  const [editor] = useLexicalComposerContext();
  return (
    <EditorContext.Provider value={{ editor }}>
      {children}
    </EditorContext.Provider>
  );
};

export default EditorContextProvider;
